import { render, staticRenderFns } from "./DeliveryInvoiceForm.vue?vue&type=template&id=0597893c&"
import script from "./DeliveryInvoiceForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryInvoiceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports